import { render, staticRenderFns } from "./VoidTransactions.vue?vue&type=template&id=46f9fa12&"
import script from "./VoidTransactions.vue?vue&type=script&lang=js&"
export * from "./VoidTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports